import React, { Component } from "react";
import SpintrLoader from "src/ui/components/Loader";
import { RouteComponentProps } from "react-router";

interface IProps extends RouteComponentProps {}

class SuggestionsView extends Component<IProps> {
    componentDidMount(): void {
        window.open("https://ideas.spintr.com");
        this.props.history.push("/");
    }

    render() {
        return (
            <div className="SuggestionsView">
                <SpintrLoader />
            </div>
        );
    }
}

export default SuggestionsView;
